import React from "react";
import { SearchInputComponent } from "../../../../common/components";
import { ServiceListSearchAndFiltersProps } from "../service-management-types";
import { Stack, Badge } from "@mui/material";
import FilterIcon from "../../../../assets/icons/filter-icon.svg";
import PlusIcon from "../../../../assets/icons/plus-icon.svg";
import Filter from "./filter";
import "./provider-service-search-filters.scss";

const ServiceListSearchAndFilters: React.FC<
  ServiceListSearchAndFiltersProps
> = ({
  onSearch,
  onFilterChange,
  onResetFilters,
  filterValues,
  placeholder = "Search by Business name, Business Type, Request ID etc.",
  appliedFiltersCount = 0,
  isFilterOpen = false,
  showFilter = true,
  setIsFilterOpen,
  searchRef,
  isReset = false,
  localSearchText,
  createServiceHandler,
  actionText
}) => {
  return (
    <>
      {/* Top search + actions */}
      <div className="search-and-filters-wrapper service-list-search-and-filters-wrapper">
        <div className="search-input-wrapper">
          <SearchInputComponent
            placeholder={placeholder}
            onSearch={onSearch}
            ref={searchRef}
            localSearchText={localSearchText}
          />
        </div>

        <div className="service-list-filter-icon-and-button-wrapper">
          {/* Filter badge */}
          {showFilter && (
            <div
              className="service-list-icon-filter filter-icon-wrapper"
              onClick={() => setIsFilterOpen?.(true)}
              tabIndex={0}
            >
              <Stack
                spacing={4}
                direction="row"
                sx={{ color: "action.active" }}
              >
                <Badge
                  color="secondary"
                  badgeContent={appliedFiltersCount}
                  invisible={appliedFiltersCount === 0}
                >
                  <div className="icon-image-and-text">
                    <img src={FilterIcon} alt="Filter Icon" />
                    Filter
                  </div>
                </Badge>
              </Stack>
            </div>
          )}

          {/* Create Service */}
          <button
            className="action-btn approve-button create-service-button"
            onClick={createServiceHandler}
          >
            {actionText}
            <img src={PlusIcon} alt="Create Service" className="plus-icon" />
          </button>
        </div>
      </div>
      <Filter
        open={isFilterOpen}
        onClose={() => setIsFilterOpen?.(false)}
        initialValues={filterValues}
        onApply={(filters) => {
          if(onFilterChange) onFilterChange(filters);
        }}
        onReset={() => {
          onResetFilters?.();
          // setIsFilterOpen?.(false);
        }}
      />
    </>
  );
};

export default ServiceListSearchAndFilters;
